

import ClinicAdminDashboard from "../Components/Dashboard/Dashboard";
import ChangePassword from "../Components/MyProfile/change-password";
import NewReport from "../Components/InvestigationReport/NewReport";
import Reports from "../Components/InvestigationReport/Reports";
import ViewReport from "../Components/InvestigationReport/ViewReport";
import SearchPatient from "../Components/SearchPatient/SearchPatient";
import TestProfileList from "../Components/LabReport/LabProfile/TestProfileList";
import ReportList from "../Components/LabReport/ReportTest/ReportList";
import AddReportForm from "../Components/LabReport/ReportTest/AddReportForm";
import PatientList from "../Components/Patient/PatientList";
import TestList from "../Components/TestReport/TestList";
import MainTest from "../Components/MainTest/MainTest";
import AddTest from "../Components/MainTest/AddTest";
import PackageList from "../Components/Packages/PackageList";
import AddPackage from "../Components/Packages/AddPackage";
import AddTestResult from "../Components/TestReport/AddTestResult";
import DoctorList from "../Components/DoctorManagment/DoctorList";
import AddDoctor from "../Components/DoctorManagment/AddDoctor";
import Home from "../Components/LabProfile/Home";
import UnitList from "../Components/UnitManagment/UnitList";
import DepartmentList from "../Components/ManageDepartment/DepartmentList";
import SampleList from "../Components/ManageSample/SampleList";
import EquipmentList from "../Components/ManageEquipment/EquipmentList";
import MethodList from "../Components/TestMethod/MethodList";
import EditReportForm from "../Components/LabReport/ReportTest/EditReportForm";
import EditTest from "../Components/MainTest/EditTest";
import EditPackage from "../Components/Packages/EditPackage";
import EditDoctor from "../Components/DoctorManagment/EditDoctor";
import LadgerList from "../Components/ladger/LadgerList";
import ViewDetailLedger from "../Components/ladger/ViewDetailLedger";
import TransactionList from "../Components/Transcation/TransactionList";
import SettingList from "../Components/Setting/SettingList";
import PayinPayout from "../Components/PayInPayOut/PayinPayout";
import ViewRefrralTest from "../Components/DoctorManagment/ViewRefrralTest";
import LabUserList from "../Components/LabUser/LabUserList";
import AddUser from "../Components/LabUser/AddUser";
import EditUser from "../Components/LabUser/EditUser";
import CollectionList from "../Components/Collection/CollectionList";
import HeaderHome from "../Components/Setting/HeaderHome";
import FooterHome from "../Components/Setting/FooterHome";
import LabSettings from "../Components/Setting/LabSettings";
import UpdatePlane from "../Components/UpdatePlan/UpdatePlane";
import SampleCollectionList from "../Components/CollectedSample/SampleCollectionList";
import OrderSampleCollection from "../Components/CollectedSample/OrderSampleCollection";

export const routes = [
	// Dashboard
	{ path: `${process.env.PUBLIC_URL}/dashboard`, Component: <ClinicAdminDashboard />, menu_key: 'dashboard' },

	// Change Password
	{ path: `${process.env.PUBLIC_URL}/change-password`, Component: <ChangePassword /> },

	// Search Patient
	{ path: `${process.env.PUBLIC_URL}/search-patient`, Component: <SearchPatient /> },

	// Report
	{ path: `${process.env.PUBLIC_URL}/reports`, Component: <Reports /> },
	{ path: `${process.env.PUBLIC_URL}/add-report`, Component: <NewReport /> },
	{ path: `${process.env.PUBLIC_URL}/view-report/:id`, Component: <ViewReport /> },
	{ path: `${process.env.PUBLIC_URL}/patient-list`, Component: <PatientList /> },
	{ path: `${process.env.PUBLIC_URL}/test-list`, Component: <TestList /> },
	{ path: `${process.env.PUBLIC_URL}/test-profile`, Component: <TestProfileList /> },
	{ path: `${process.env.PUBLIC_URL}/parameter-list`, Component: <ReportList /> },
	{ path: `${process.env.PUBLIC_URL}/add-parameter`, Component: <AddReportForm /> },
	{ path: `${process.env.PUBLIC_URL}/list-test`, Component: <MainTest /> },
	{ path: `${process.env.PUBLIC_URL}/add-test`, Component: <AddTest /> },
	{ path: `${process.env.PUBLIC_URL}/package-list`, Component: <PackageList /> },
	{ path: `${process.env.PUBLIC_URL}/add-package`, Component: <AddPackage /> },
	{ path: `${process.env.PUBLIC_URL}/Add-test_result/:id`, Component: <AddTestResult /> },
	{ path: `${process.env.PUBLIC_URL}/doctors-list`, Component: <DoctorList /> },
	{ path: `${process.env.PUBLIC_URL}/add-doctors`, Component: <AddDoctor /> },
	{ path: `${process.env.PUBLIC_URL}/update-profile`, Component: <Home /> },
	{ path: `${process.env.PUBLIC_URL}/unit-list`, Component: <UnitList /> },
	{ path: `${process.env.PUBLIC_URL}/department-list`, Component: <DepartmentList /> },
	{ path: `${process.env.PUBLIC_URL}/sample-list`, Component: <SampleList /> },
	{ path: `${process.env.PUBLIC_URL}/equipment-list`, Component: <EquipmentList /> },
	{ path: `${process.env.PUBLIC_URL}/test-method-list`, Component: <MethodList /> },
	{ path: `${process.env.PUBLIC_URL}/edit-parameter/:id`, Component: <EditReportForm /> },
	{ path: `${process.env.PUBLIC_URL}/edit-test/:id`, Component: <EditTest /> },
	{ path: `${process.env.PUBLIC_URL}/edit-package/:id`, Component: <EditPackage /> },
	{ path: `${process.env.PUBLIC_URL}/edit-doctor/:id`, Component: <EditDoctor /> },
	{ path: `${process.env.PUBLIC_URL}/ledger`, Component: <LadgerList /> },
	{ path: `${process.env.PUBLIC_URL}/transcation`, Component: <TransactionList /> },
	{ path: `${process.env.PUBLIC_URL}/setting`, Component: <SettingList /> },
	{ path: `${process.env.PUBLIC_URL}/pay`, Component: <PayinPayout /> },
	{ path: `${process.env.PUBLIC_URL}/user`, Component: <LabUserList /> },
	{ path: `${process.env.PUBLIC_URL}/add-user`, Component: <AddUser /> },
	{ path: `${process.env.PUBLIC_URL}/collection`, Component: <CollectionList /> },
	{ path: `${process.env.PUBLIC_URL}/edit-user/:id`, Component: <EditUser /> },
	{ path: `${process.env.PUBLIC_URL}/view-transaction/:id`, Component: <ViewDetailLedger /> },
	{ path: `${process.env.PUBLIC_URL}/view-customer/:id`, Component: <ViewRefrralTest /> },
	{ path: `${process.env.PUBLIC_URL}/header-setting`, Component: <HeaderHome /> },
	{ path: `${process.env.PUBLIC_URL}/footer-setting`, Component: <FooterHome /> },
	{ path: `${process.env.PUBLIC_URL}/settings`, Component: <LabSettings /> },
	{ path: `${process.env.PUBLIC_URL}/conversion-setting`, Component: <LabSettings /> },
	{ path: `${process.env.PUBLIC_URL}/date-time-format`, Component: <LabSettings /> },
	{ path: `${process.env.PUBLIC_URL}/current-plan`, Component: <UpdatePlane /> },
	{ path: `${process.env.PUBLIC_URL}/collected-sample`, Component: <SampleCollectionList /> },
	{ path: `${process.env.PUBLIC_URL}/sample-collection/:id`, Component: <OrderSampleCollection /> },
];
